import React from "react";
import { Input } from "../../../shared/Input/Input";
import { TextCustom } from "../../../ui/TextCustom";

interface IAddFeatureModalItemProps {
    label: string;
    value: string;
    placeholder: string;
    formRef: React.MutableRefObject<HTMLFormElement | null>;
    func: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const AddFeatureModalItem: React.FC<IAddFeatureModalItemProps> = ({label, value, placeholder, formRef, func}) => {
    return (
        <div style={{width:'100%', display:'grid', gridTemplateColumns:'100px 1fr', alignItems:'center', gap:'1rem'}}>
            <TextCustom weight={400} color="dark" size={1.2}>{label}</TextCustom>
            <Input stretch placeholder={placeholder} formRef={formRef} func={func} value={value} />
        </div>
    )
}